import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ConfigService } from 'app/core/services/config.service';
import { RequestService } from 'app/core/services/request.service';
import {CatalogDetails} from '../catalogs/details/catalog-details.model';

@Injectable()
export class BrandService {

    constructor(
        private configService: ConfigService,
        private requestService: RequestService
    ) { }

    addBrand(details: any): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.brands.add.api;
        return this.requestService.post(url, details);
    }
    deleteBrand(details: any): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.brands.delete.api;
        return this.requestService.post(url, details);
    }
    editBrand(details: any): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.brands.edit.api;
        return this.requestService.post(url, details);
    }
    getBrandList(): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.brands.list.api;
        return this.requestService.get(url);
    }

    details(id: string): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.brands.details.api + '/' + id;
        return this.requestService.get(url);
    }
    formatBrandsToDict(brandsArray: Array<any>) {
        let result = [];
        brandsArray.forEach(el => {
            if(el.hasOwnProperty('id')) {
                result.push({
                    key: el.id,
                    value: el.name,
                    image: el.image
                })
            }
        });
        return result
    }

    getDetailsFields() {
        let fields = [
            {
                key: 'name',
                label: 'Name',
                type: 'text'
            },
            {
                key: 'description',
                label: 'Description',
                type: 'textarea'
            },
            {
                key: 'image',
                label: 'Brand Image',
                type: 'img-preview'
            }
        ];
        return fields;
    }
}



// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/brands/brand.service.ts